import React from 'react';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../config/i18n/slice';
import { Button, Divider } from 'semantic-ui-react';
import { useHistory } from "react-router";
const EmptyFilter = ({people=true, team=false}) => {
    const t = useSelector(selectTranslations);
    const history = useHistory();
    const userRole = useSelector((state) => {
      if (state?.auth?.user?.role?.id) {
        return state?.auth?.user?.role?.type;
      } else {
        return null;
      }
    });
  return (
    // <div className="filters">
    //     <div className="text-right mb-5 pb-5 d-flex justify-content-between align-items-center views">
    //       <div className="list-view-option">
    //         <p className={`single-view ${userRole == "requester" ? "d-none" : ""}`}>
    //           <NavLink to="/people">{t.teams.filter.people}</NavLink>
    //         </p>
    //         <p className="single-view">
    //           <NavLink to="/teams">{t.people.filter.teams}</NavLink>
    //         </p>
    //       </div>
    //     </div>
    //   </div>

    <div className="table-header-dashbaord team-filter filters">
    <Button.Group
      className="add-people-btn part"
      basic
      fluid
      size="medium"
    >
      <Button className={`${userRole == "requester" ? "d-none" : ""}`} type="button" onClick={() => history.push("/people")} active={people}>
      {t.teams.filter.people}
      </Button>

      <Button type="button"  active={team} onClick={() => history.push("/teams")}>
      {t.people.filter.teams}
      </Button>
    </Button.Group>

    <Divider className="part-divider mt-0 mb-8" />
  </div>
  )
}

export default EmptyFilter